import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestHandlerService, RequestOptionsModel } from "bnsights-utilities-library";
import { WFVariableModel } from './../models/WorkflowModels/WFVariableModel';

@Injectable({
    providedIn: 'root'
})
export class WorkflowVariablesService {
    ApiUrl = "/api/admin/WorkflowVariable/"
    constructor(private http: RequestHandlerService) {
    }

    Loaddropdowns() {
       
        return this.http.get( this.ApiUrl + 'Loaddropdowns');
    }

    AddVariable(AddModel: WFVariableModel) {
        return this.http.post( this.ApiUrl + 'AddVariable', AddModel);
    }

    EditVariable(EditModel:WFVariableModel) {
       
        return this.http.post( this.ApiUrl + 'EditVariable', EditModel);
    }


    DeleteVariable(id: number) {
      
        return this.http.post( this.ApiUrl + 'DeleteVariable', id);
    }


  

}